import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CalendarIcon, ZapIcon, ShieldCheckIcon, HeartIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-4 relative overflow-hidden bg-background" data-id="element-273">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-274">
        <FadeIn data-id="element-275">
          <div className="bg-gradient-to-br from-primary/10 via-card to-background border border-primary/20 rounded-xl p-4 md:p-6 shadow-xl relative overflow-hidden" data-id="element-276">
            <div className="absolute top-0 right-0 w-48 h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-277" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-secondary/10 rounded-full blur-3xl pointer-events-none" data-id="element-278" />

            <div className="text-center mb-4 relative z-10" data-id="element-279">
              <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary/20 text-primary mb-2" data-id="element-280">
                <CalendarIcon className="w-5 h-5" data-id="element-281" />
              </div>
              <h2 className="text-xl md:text-2xl font-black mb-1 text-gray-900" data-id="element-282">
                Lo que cambia en{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-283">
                  7 días
                </span>
              </h2>
              <p className="text-sm text-primary font-medium" data-id="element-284">
                Prueba de Credibilidad
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-3 relative z-10" data-id="element-285">
              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-card-border" data-id="element-286">
                <ZapIcon className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-287" />
                <div data-id="element-288">
                  <h3 className="text-sm font-bold text-gray-900 mb-0.5" data-id="element-289">
                    Estructura inmediata
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-290">
                    Tus clases ganan orden y fluidez; planificás más rápido y
                    sin perder tiempo.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-card-border" data-id="element-291">
                <ShieldCheckIcon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-292" />
                <div data-id="element-293">
                  <h3 className="text-sm font-bold text-gray-900 mb-0.5" data-id="element-294">
                    Seguridad y autoridad
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-295">
                    Respondés cada "¿por qué?" con criterio profesional y te
                    sentís respaldado.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg border border-card-border" data-id="element-296">
                <HeartIcon className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-297" />
                <div data-id="element-298">
                  <h3 className="text-sm font-bold text-gray-900 mb-0.5" data-id="element-299">
                    Mejor experiencia
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed" data-id="element-300">
                    Técnica más precisa, más confianza en tu trabajo y
                    prevención real de lesiones.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}